import React, { Component } from 'react'

export default class ToggleButton extends Component {
    render() {
        return (
            <div className="toggleButtonStyle" onClick={this.props.onToggleClick} style={this.props.selected ? {backgroundColor:this.props.color,color:'white',borderRadius:this.props.color==="var(--green1)" ? '0px 8px 8px 0px':'8px 0px 0px 8px',borderWidth:'0px'}:{borderColor:'var(--gray2)',backgroundColor:'var(--white1)',color:'var(--gray2)',borderRadius:this.props.color==="var(--green1)" ? '0px 8px 8px 0px':'8px 0px 0px 8px',borderWidth:this.props.color==="var(--green1)"?'1px 1px 1px 0px':'1px 0px 1px 1px'}}>
                {this.props.text}
            </div>
        )
    }
}
